import { CmsLink } from '../../cmsTypes/cmsLink'
import { Link } from 'react-router-dom'
import { urlService } from '../..'
import { FC, ReactNode } from 'react'

export const CmsLinkComponent: FC<{
    link: CmsLink
    onClick?: () => void
    class?: string
    children: ReactNode
}> = props => {
    const { link } = props

    if (!link) return null

    if (urlService.isRouted(link?.url))
        return (
            <>
                <Link
                    to={link.url.replace(document.location.origin, '')}
                    target={link.target}
                    className={props.class ? props.class : ''}
                    onClick={() => (props.onClick ? props.onClick() : () => {})}
                >
                    {!props.children && link.name}
                    {props.children && props.children}
                </Link>
            </>
        )

    return (
        <>
            <a target={link.target} href={link.url} className={props.class ? props.class : ''}>
                {!props.children && link.name}
                {props.children && props.children}
            </a>
        </>
    )
}
